// extracted by mini-css-extract-plugin
export default {"matchScore":"MatchScore_matchScore__hrJ0o","firstTeam":"MatchScore_firstTeam__enU1R","score":"MatchScore_score__jsppO","secondTeam":"MatchScore_secondTeam__KZmME"};